// src/utils/normalizeError.js
export function normalizeApiError(err) {
  const data = err?.response?.data;
  if (data) {
    if (typeof data.detail === "string") return data.detail;

    if (Array.isArray(data.detail)) {
      const msgs = data.detail
        .map(item => {
          if (item?.msg) return item.msg;
          const loc = Array.isArray(item?.loc) ? item.loc.join(".") : item?.loc;
          return [loc, item?.type].filter(Boolean).join(": ");
        })
        .filter(Boolean);

      return msgs.length ? msgs.join("; ") : "Validation error";
    }

    if (typeof data.message === "string") return data.message;
    if (typeof data.error === "string") return data.error;
    if (typeof data === "string") return data;

    try {
      return JSON.stringify(data);
    } catch {
      return "Unknown error";
    }
  }

  if (typeof err?.message === "string") return err.message;
  return "Request failed";
}
